import { AdvancedTourStep } from '../shared-types';
import { ComponentTourProps } from './component-tour-props';

export function getTaskConfigurationTourSteps({
	defaultStyles,
}: ComponentTourProps): AdvancedTourStep[] {
	return [
		{
			id: 'task-drawer',
			selector: '[data-tour="task-drawer"]',
			content: 'Manage your task settings within the configuration drawer.',
		},
		{
			id: 'right-drawer-width-toggle',
			selector: '[data-tour="right-drawer-width-toggle"]',
			content: 'This control allows you to toggle the full-width of the drawer.',
		},
		{
			id: 'right-drawer-collapse',
			selector: '[data-tour="right-drawer-collapse"]',
			content: 'This control allows you to collapse the drawer completely hiding it.',
		},
		{
			id: 'general-tab',
			selector: '[data-tour="general-tab"]',
			content: 'Manage the general basic settings of the task.',
		},
		{
			id: 'input-tab',
			selector: '[data-tour="input-tab"]',
			content: 'Set the input structure of the data that would be processed by the task.',
		},
		{
			id: 'output-tab',
			selector: '[data-tour="output-tab"]',
			content: 'View the resolved values from the input data.',
		},
		{
			id: 'advanced-tab',
			selector: '[data-tour="advanced-tab"]',
			content:
				'Set rules and additional constraints on how the task handles the incoming data and how it should handle the processing of the data.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
